import { useEffect, useState } from "react";

const KEY = "apex_compare";
const EVENT = "apex-compare-change";
export const MAX_COMPARE = 2;

function read() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(raw) ? raw.slice(0, MAX_COMPARE) : [];
  } catch {
    return [];
  }
}

function write(slugs) {
  try { localStorage.setItem(KEY, JSON.stringify(slugs)); } catch {}
  window.dispatchEvent(new Event(EVENT));
}

export function useCompare() {
  const [slugs, setSlugs] = useState(read);

  useEffect(() => {
    const sync = () => setSlugs(read());
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const toggle = (slug) => {
    const current = read();
    if (current.includes(slug)) {
      write(current.filter((s) => s !== slug));
      return "removed";
    }
    if (current.length >= MAX_COMPARE) {
      write([current[current.length - 1], slug]); // keep the newest pick, drop the oldest
      return "swapped";
    }
    write([...current, slug]);
    return "added";
  };

  return {
    slugs,
    toggle,
    remove: (slug) => write(read().filter((s) => s !== slug)),
    clear: () => write([]),
    isPinned: (slug) => slugs.includes(slug),
    isFull: slugs.length >= MAX_COMPARE,
  };
}
